const CHANNEL_OPTIONS = ["SMS", "WHATSAPP", "EMAIL", "WEBHOOK"];

const TENANT_NOTIFICATION_TYPE_OPTIONS = [
  {
    value: "BEFORE_DUE",
    label: "Before due date",
    description: "Send exactly N days before the due date.",
  },
  {
    value: "ON_DUE",
    label: "On due date",
    description: "Send on the due date day (offset usually 0).",
  },
  {
    value: "AFTER_DUE",
    label: "After due date",
    description: "Send exactly N days after the due date.",
  },
  {
    value: "OVERDUE_AT_LEAST_N_DAYS",
    label: "Overdue at least N days",
    description: "Send when overdue days are greater than or equal to N.",
  },
  {
    value: "OVERDUE_BETWEEN_N_AND_M_DAYS",
    label: "Overdue between N and M days",
    description: "Send when overdue days are within range N to M.",
  },
  {
    value: "DUE_IN_AT_MOST_N_DAYS",
    label: "Due in at most N days",
    description: "Send when due date is less than or equal to N days away.",
  },
  {
    value: "DUE_BETWEEN_N_AND_M_DAYS",
    label: "Due between N and M days",
    description: "Send when due date is within range N to M days away.",
  },
];

const TENANT_SCOPE_OPTIONS = ["ALL_TENANCIES"];

const PAYOUT_NOTIFICATION_TYPE_OPTIONS = [
  {
    value: "BEFORE_PAYDAY",
    label: "Before payday",
    description: "Send exactly N days before payday.",
  },
  {
    value: "ON_PAYDAY",
    label: "On payday",
    description: "Send on payday day (offset usually 0).",
  },
  {
    value: "AFTER_PAYDAY",
    label: "After payday",
    description: "Send exactly N days after payday.",
  },
];

const DISPATCH_STATUS_OPTIONS = ["PENDING", "SENT", "FAILED", "SKIPPED"];

export {
  CHANNEL_OPTIONS,
  TENANT_NOTIFICATION_TYPE_OPTIONS,
  TENANT_SCOPE_OPTIONS,
  PAYOUT_NOTIFICATION_TYPE_OPTIONS,
  DISPATCH_STATUS_OPTIONS,
};
